<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="backButtonPressed()" defaultHref="/"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <loader *ngIf="isLoading"></loader>
  <h1>{{username}}</h1>
  <h2>
    <medal rank='{{boulderRank??0}}' slot="start"></medal>
    {{"profile-page.of-the-best-boulderers" | translate}} <medal rank='{{creatorRank??0}}' slot="start"></medal>
    {{"profile-page.of-the-best-creators" | translate}}
  </h2>
  <grade-pryamid *ngIf="bouldersSentByUser" [boulders]="bouldersSentByUser"></grade-pryamid>
  <ion-segment mode="md" (ionChange)="listTypeChanged($event)" [value]="listType" color="secondary">
    <ion-segment-button value="ascents">
      <ion-label>{{"profile-page.ascents" | translate}}</ion-label>
    </ion-segment-button>
    <ion-segment-button value="definitions">
      <ion-label>{{"profile-page.definitions" | translate}}</ion-label>
    </ion-segment-button>
  </ion-segment>
  <div *ngIf="listType==='ascents'">
    <my-ascent-list *ngIf="!isLoading" username="{{username}}"></my-ascent-list>
  </div>
  <div *ngIf="listType==='definitions'">
    <ion-list>
      <ion-item>
        <ion-label slot="start">{{"profile-page.boulders-created" | translate}}</ion-label>
        <ion-label slot="end">{{bouldersCreatedByUser.length}}</ion-label>
      </ion-item>
      <ion-item>
        <ion-label slot="start">{{"profile-page.average-grade" | translate}}</ion-label>
        <ion-label slot="end" [class]="avarageThumbUps<0 ? 'bad-boulder': 'good-boulder'"><ion-icon
            *ngIf="avarageThumbUps>0" class="good-boulder" name="thumbs-up"></ion-icon><ion-icon
            *ngIf="avarageThumbUps<0" class="bad-boulder" name="thumbs-down"></ion-icon> {{avarageThumbUps}}</ion-label>
      </ion-item>
      <ion-item>
        <ion-label slot="start">{{"profile-page.boulders-upgraded" | translate}}</ion-label>
        <ion-label slot="end">{{numberOfOwnBouldersUpgraded}} / {{percentOwnBouldersUpgraded}}%</ion-label>
      </ion-item>
      <ion-item>
        <ion-label slot="start">{{"profile-page.boulders-downgraded" | translate}}</ion-label>
        <ion-label slot="end">{{numberOfOwnBouldersDowngraded}} / {{percentOfOwnBouldersDowngraded}}%</ion-label>
      </ion-item>
    </ion-list>
    <app-boulder-list-entry (click)="showBoulder(boulder.boulderId)" *ngFor="let boulder of bouldersCreatedByUser"
      [boulder-list-entry]="boulder"></app-boulder-list-entry>
  </div>
</ion-content>